import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "@/data/content";

const ANCHORS = {
  Features: "/#features",
  Pricing: "/#pricing",
  Workouts: "/#features",
  Nutrition: "/#nutrition",
  Community: "/#community",
  Contact: "/#contact",
  Blog: "/blog",
  Press: "/press",
  "Help Center": "/help",
  "Privacy Policy": "/privacy",
  "Terms of Service": "/terms",
};

const ROUTE_LINKS = new Set(["Blog", "Press", "Help Center", "Privacy Policy", "Terms of Service"]);

const linkCols = [
  { title: "Product", links: ["Features", "Pricing", "Workouts", "Nutrition", "Community"] },
  { title: "Company", links: ["About", "Careers", "Blog", "Press"] },
  { title: "Support", links: ["Help Center", "Contact", "Privacy Policy", "Terms of Service"] },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-charcoal border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 pb-12 border-b border-white/10">
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-2">
              <img src={IMAGES.logo} alt="AlphaPulse Fitness App" className="h-40 w-auto mix-blend-screen" />
            </Link>
            <p className="text-white/55 mt-4 max-w-xs leading-relaxed">
              The all-in-one fitness platform by Alpha Omega Vitality. Train smarter, eat better, stay connected.
            </p>
          </div>

          {linkCols.map((col) => (
            <div key={col.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm uppercase tracking-widest text-white/90 mb-4">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l}>
                    {ROUTE_LINKS.has(l) ? (
                      <Link
                        to={ANCHORS[l]}
                        data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-sm text-white/55 hover:text-vitality transition-colors"
                      >
                        {l}
                      </Link>
                    ) : (
                      <a
                        href={ANCHORS[l] || "#"}
                        data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-sm text-white/55 hover:text-vitality transition-colors"
                      >
                        {l}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-6 pt-8">
          <p className="text-sm text-white/45">
            © {new Date().getFullYear()} AlphaPulse · Alpha Omega Vitality. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
